import { render, staticRenderFns } from "./PropertiesLeased.vue?vue&type=template&id=00f1e927&scoped=true&"
import script from "./PropertiesLeased.vue?vue&type=script&lang=ts&"
export * from "./PropertiesLeased.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1e927",
  null
  
)

export default component.exports